"use strict";

var _classCallCheck = require("C:\\Projects\\Business\\Ordaap\\ordaap-chat-codebase\\ordaap-backend\\components\\guest-app\\node_modules\\@babel\\runtime/helpers/classCallCheck");

var _createClass = require("C:\\Projects\\Business\\Ordaap\\ordaap-chat-codebase\\ordaap-backend\\components\\guest-app\\node_modules\\@babel\\runtime/helpers/createClass");

var _possibleConstructorReturn = require("C:\\Projects\\Business\\Ordaap\\ordaap-chat-codebase\\ordaap-backend\\components\\guest-app\\node_modules\\@babel\\runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("C:\\Projects\\Business\\Ordaap\\ordaap-chat-codebase\\ordaap-backend\\components\\guest-app\\node_modules\\@babel\\runtime/helpers/getPrototypeOf");

var _inherits = require("C:\\Projects\\Business\\Ordaap\\ordaap-chat-codebase\\ordaap-backend\\components\\guest-app\\node_modules\\@babel\\runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var paho_mqtt_1 = require("../../clients/paho-mqtt");

var pb_1 = require("./pb");

var ExtendedDepartmentNotification =
/*#__PURE__*/
function (_pb_1$DepartmentNotif) {
  _inherits(ExtendedDepartmentNotification, _pb_1$DepartmentNotif);

  function ExtendedDepartmentNotification(properties) {
    var _this;

    _classCallCheck(this, ExtendedDepartmentNotification);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ExtendedDepartmentNotification).call(this, properties));
    _this.type = ExtendedDepartmentNotification.type;
    return _this;
  }

  _createClass(ExtendedDepartmentNotification, [{
    key: "toMQTT",
    value: function toMQTT() {
      var topic = "".concat(this.property).concat(ExtendedDepartmentNotification.context, "/").concat(this.department);
      var mqttMessage = new paho_mqtt_1.Message(pb_1.DepartmentNotification.encode(this).finish());
      mqttMessage.destinationName = topic;
      mqttMessage.qos = 1;
      return mqttMessage;
    }
  }], [{
    key: "fromMQTT",
    value: function fromMQTT(mqttMessage) {
      return new ExtendedDepartmentNotification(pb_1.DepartmentNotification.decode(mqttMessage.payloadBytes));
    }
  }]);

  return ExtendedDepartmentNotification;
}(pb_1.DepartmentNotification);

ExtendedDepartmentNotification.type = "DepartmentNotification";
ExtendedDepartmentNotification.context = "/department-notification";
exports.DepartmentNotification = ExtendedDepartmentNotification;